import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react'
import SearchableSelect from './SearchableSelect'

// Paginação server-side PADRÃO (réplica fiel do original `es`): controles centralizados +
// "Mostrando X a Y de Z" + seletor "N por página". SEMPRE visível em todas as listas.
export default function Pagination({ page = 1, pages = 1, total = 0, pageSize = 20, onPage, onPageSize }) {
  const totalPages = Math.max(1, pages || 1)
  const go = (p) => onPage && onPage(Math.min(totalPages, Math.max(1, p)))
  const start = Math.max(1, page - 2)
  const end = Math.min(totalPages, page + 2)
  const nums = []
  for (let i = start; i <= end; i++) nums.push(i)
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1
  const to = Math.min(page * pageSize, total)
  const nav = 'p-1.5 rounded-lg hover:bg-primary-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-primary-700'

  return (
    <div className="flex flex-col items-center gap-3 mt-4 px-1">
      <div className="flex items-center gap-1">
        <button onClick={() => go(1)} disabled={page <= 1} className={nav} title="Primeira"><ChevronsLeft size={18} /></button>
        <button onClick={() => go(page - 1)} disabled={page <= 1} className={nav} title="Anterior"><ChevronLeft size={18} /></button>
        {nums.map((n) => (
          <button key={n} onClick={() => go(n)}
            className={`w-8 h-8 rounded-lg text-sm font-medium transition-all ${n === page ? 'bg-gradient-to-br from-primary-500 to-accent-500 text-white shadow-md' : 'hover:bg-primary-50 text-gray-600'}`}>{n}</button>
        ))}
        <button onClick={() => go(page + 1)} disabled={page >= totalPages} className={nav} title="Próxima"><ChevronRight size={18} /></button>
        <button onClick={() => go(totalPages)} disabled={page >= totalPages} className={nav} title="Última"><ChevronsRight size={18} /></button>
      </div>
      <div className="flex items-center gap-3 text-sm text-gray-500">
        <span>Mostrando <b className="text-primary-700">{from}</b> a <b className="text-primary-700">{to}</b> de <b className="text-primary-700">{total}</b></span>
        {onPageSize && (
          <SearchableSelect value={pageSize} onChange={(v) => onPageSize(Number(v))} emptyOption={false} className="w-36"
            options={[10, 20, 50, 100].map((p) => ({ value: p, label: `${p} por página` }))} />
        )}
      </div>
    </div>
  )
}
